<template>
  <div
    v-if="errors.length"
    class="RMPE-MessageError"
  >
    <div
      v-for="error in errors"
      :key="error.type"
    >
      <div
        v-if="!error.status && isBlurred || !error.status && manualValidate"
        class="help is-danger"
        :class="classes"
      >
        {{ error.message }}
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    errors: {
      type: Array,
      default() {
        return [];
      },
    },
    manualValidate: {
      type: Boolean,
      default: false,
    },
    serverValidation: {
      type: String,
      default: '',
    },
    isBlurred: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showValidation: false,
    };
  },
};
</script>
<style scoped lang="scss">
.RMPE-MessageError {}
</style>
